export const URL_API = import.meta.env.VITE_URL_API;
async function request(method: string, URI: RequestInfo | URL, data: any = {}): Promise<any> {
  const headers: any = {
    'Content-type': 'application/json; charset=UTF-8',
    'Accept': 'application/json'
  };

  if (localStorage.getItem('pravaler_token')) {
    headers.Authorization = `Bearer ${localStorage.getItem('pravaler_token')}`;
  }

  const init: Record<string, any> = {
    method,
    headers,
    credentials: 'include'
  };
  const url = new URL(URL_API + URI);

  if (method !== 'GET') {
    init.body = JSON.stringify({ ...data });
  } else {
    url.search = new URLSearchParams(data).toString();
  }

  const response = await fetch(url, init);

  if (response.status === 204) {
    return { status: response.status };
  }
  const json = await response.json();

  if (!response.ok) {
    throw new Error(json.message);
  }
  return { status: response.status, body: json };
}

function get(URI: RequestInfo | URL, data: any = {}): Promise<any> {
  return request('GET', URI, data);
}

function post(URI: RequestInfo | URL, data: any = {}): Promise<any> {
  return request('POST', URI, data);
}

function destroy(URI: RequestInfo | URL, data: any = {}): Promise<any> {
  return request('DELETE', URI, data);
}
function put(URI: RequestInfo | URL, data: any = {}): Promise<any> {
  return request('PUT', URI, data);
}

export {
  request,
  get,
  post,
  put,
  destroy
};
